import { Component } from 'react';
import Timeline from '../../../../components/Timeline';

import keys from './keys';
import { colors } from '../../../../lib/colors';
import { withTranslation } from 'react-i18next';

class Chart extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;
        const chartData = (datasetIndex) => ({
            labels: this.props.selectedItem?.dateL.map((item) => item.value),
            datasets: keys(t).map((item, i) => ({
                label: item.label,
                type: item.type || 'line',
                data: this.props.selectedItem[item.key],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                backgroundColor: colors[i],
                yAxisID: item.yAxisID || 'y',
                hidden: item.hidden || false,
                borderRadius: 4,
                tension: 0.4,
            })),
        });
        return (
            <Timeline
                dontShowMetrics
                chartSize="lg"
                metricType="primary"
                data={chartData()?.labels?.map((x) => ({ date: x }))}
                keys={keys(t)}
                chartData={chartData}
                forceRun={this.props.forceRun}
                parent_id={this.props.parent_id}
                content_id={this.props.content_id}
                hasRightAxis
                rightAxisLabel={t('global.ctr_per')}
                rightSecondAxisLabel={t('global.positions')}
                hasSecondRightAxis
                showGoogleFeeds
                hasLeftSecondAxis
                leftSecondAxisLabel={t('global.clicks')}
                leftAxisLabel={t('global.impressions')}
                header={this.props.header}
            />
        );
    }
}

export default withTranslation()(Chart);
